import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Pageheader from "./sections/Pageheader";
import Inpagenav from "./sections/Inpagenav";
import Thevemarkpromise from "./sections/Thevemarkpromise";
import Ourprocess from "./sections/Ourprocess";
import Capabilities from "./sections/Capabilities";
import Quality from "./sections/Quality";
import Madeinusa from "./sections/Madeinusa";
import Faqaccordion from "./sections/Faqaccordion";
import Closingcta from "./sections/Closingcta";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <Pageheader />
      <Inpagenav />
      <Thevemarkpromise />
      <Ourprocess />
      <Capabilities />
      <Quality />
      <Madeinusa />
      <Faqaccordion />
      <Closingcta />
      <Footer />
    </div>;
}